import {APIError} from 'helpers/Rest';
import * as ServerActions from "./ServerActions";

export function getProducts(filters) {
  return async (_dispatch, _getState, {api}) => {
    try {
      return await api.getProducts(filters);
    } catch (e) {
      throw e;
    }
  }
}

export function getPushPierProducts() {
  return async (dispatch, _getState, {api}) => {
    try {
      const productsList = await api.getPushPierProducts();
      dispatch(ServerActions.receivedPushPierProducts(productsList));
    } catch (e) {
      if (e instanceof APIError) {
        console.warn(e);
      } else {
        throw e;
      }
    }
  }
}

export function getProductTypes() {
  return async (dispatch, _getState, {api}) => {
    try {
      const productTypesList = await api.getProductTypes();
      dispatch(ServerActions.receivedProductTypes(productTypesList));
    } catch (e) {
        if (e instanceof APIError) {
          console.warn(e);
        } else {
          throw e;
        }
      }
  };
}

const ProductActions = {
  getProducts,
  getPushPierProducts,
  getProductTypes,
};

export default ProductActions;
